import { useNavigate } from "react-router";

import { RiUserFill } from "react-icons/ri";
import { useEffect, useRef, useState } from "react";
import { IoWallet } from "react-icons/io5";
import useDeviceType from "../../hook/useDeviceType";
import IconCircleWrapper from "../Icon/IconCircleWrapper";
import { BiSolidBellRing } from "react-icons/bi";
import { motion } from "framer-motion";
import HeaderInbox from "./components/headerInbox";
import { useSelector } from "react-redux";

const bellShakeAnimation = {
  rotate: [0, 20, -20, 20, -20, 0],
  transition: {
    duration: 0.5,
    ease: "easeInOut",
    times: [0, 0.2, 0.4, 0.6, 0.8, 1],
    loop: Infinity,
    repeatDelay: 1,
  },
};
const SignInData = ({}) => {
  const [openSlideMenu, setOpenSlideMenu] = useState(false);

  const slideMenuRef = useRef(null);

  const deviceType = useDeviceType();

  const inboxList = useSelector((state) => state.isInboxList);

  const handleClickOutside = (event) => {
    if (slideMenuRef.current && !slideMenuRef.current.contains(event.target)) {
      setOpenSlideMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navigate = useNavigate();
  return (
    <section className="flex items-center gap-[5px]">
      {/* <IconCircleWrapper
        divProps={{
          onClick: () => navigate("profile/deposit"),
        }}
      >
        <IoWallet className="text-xl" />
      </IconCircleWrapper> */}
      <IconCircleWrapper
        divProps={{
          onClick: () => navigate("profile/inbox"),
        }}
      >
        {inboxList?.filter((item) => item.readmsg == 0)?.length > 0 && (
          <div className="w-[5px] h-[5px] rounded-full bg-red-500 absolute top-0 right-0"></div>
        )}
        <motion.div
          // initial={{ rotate: 0 }}
          // animate={bellShakeAnimation}
          className="relative"
        >
          <BiSolidBellRing className="text-xl" />
        </motion.div>
        {/* {openInbox && <HeaderInbox inboxList={inboxList} />} */}
      </IconCircleWrapper>

      <IconCircleWrapper
        divProps={{
          onClick: () => {
            if (deviceType === "Mobile") {
              navigate("profile");
            } else {
              navigate("profile/data");
            }
          },
        }}
      >
        {" "}
        <RiUserFill className="text-xl" />
      </IconCircleWrapper>
    </section>
  );
};

export default SignInData;
